import { BoxProps, FormControl, FormHelperText } from '@mui/material';

const MissingControlPersonErrorMessage: React.FC<BoxProps> = () => {
  return (
    <FormControl error={true}>
      <FormHelperText>
        Your submission must include at least one individual with significant management responsibility.
      </FormHelperText>
    </FormControl>
  );
};

export { MissingControlPersonErrorMessage };
